import axios from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiRequest = axios.create({
    baseURL: "/api/v1/",
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Auth: "Bearer Token"
    }
})

apiRequest.interceptors.request.use(
    (config) => {
        return config; //its necessary
    },
    (err) => {
        return Promise.reject(err)
    }
)

apiRequest.interceptors.response.use(
    (response) => {
        return response;
    },
    (err) => {
        if (err.response) {
            const { status } = err.response;
            const { message } = err.response.data;
            if(message){
                toast.error(message);
            }else{
                switch (status) {
                    case 301:
                        toast.error("صفحه به آدرس جدیدی منتقل شده است.");
                        break;
                    case 302:
                        toast.error("شما به صفحه جدیدی هدایت می‌شوید.");
                        break;
                    case 304:
                        toast.error("محتوای صفحه تغییر نکرده، لطفاً کش مرورگر را بررسی کنید.");
                        break;
                    case 400:
                        toast.error("درخواست نامعتبر بود. لطفاً اطلاعات واردشده را بررسی کنید.");
                        break;
                    case 401:
                        toast.error("دسترسی غیرمجاز است. لطفاً وارد حساب کاربری خود شوید.");
                        break;
                    case 403:
                        toast.error("شما مجاز به دسترسی به این صفحه نیستید.");
                        break;
                    case 404:
                        toast.error("صفحه موردنظر یافت نشد.");
                        break;
                    case 405:
                        toast.error("این عملیات پشتیبانی نمی‌شود.");
                        break;
                    case 429:
                        toast.error("درخواست‌های زیادی ارسال شده است. لطفاً بعداً تلاش کنید.");
                        break;
                    case 500:
                        toast.error("خطای سرور رخ داده است. لطفاً بعداً دوباره تلاش کنید.");
                        break;
                    case 501:
                        toast.error("عملیات درخواست‌شده پشتیبانی نمی‌شود.");
                        break;
                    case 502:
                        toast.error("مشکلی در ارتباط با سرور وجود دارد. لطفاً دوباره تلاش کنید.");
                        break;
                    case 503:
                        toast.error("سرور موقتاً در دسترس نیست. لطفاً بعداً تلاش کنید.");
                        break;
                    case 504:
                        toast.error("درخواست شما به پایان نرسید. لطفاً دوباره تلاش کنید.");
                        break;
                    case 505:
                        toast.error("نسخه HTTP پشتیبانی نمی‌شود. لطفاً با پشتیبانی تماس بگیرید.");
                        break;
                    default:
                        toast.error("خطایی رخ داده است.");
                }
            }
        } else {
            toast.error("مشکلی در اتصال به سرور رخ داده است.");
        }
        console.log('interceptor err: ', err);
        return Promise.reject(err);
    }
);

export default apiRequest;